// DEPRECATION NOTICE: Originally from UG LMS, should be removed. https://descomplica.slack.com/archives/CJFJQQY1K/p1713359793357089

import { GetterTree } from 'vuex';

import RootState from '@/store/root_state';
import { MicrocertificateState } from './state';

const getters: GetterTree<MicrocertificateState, RootState> = {
  userMicrocertificates: (state) => {
    return state.microcertificates || [];
  },
  isGeneratingMicroCertificate: (state) => {
    return state.isGenerating;
  },
};

export default getters;
